/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import { useParams } from 'react-router-dom';
import React,{useState, useEffect} from 'react';
import { Table } from 'react-bootstrap';
import './NCUTrackersList.css';

function NCUTrackersList(props) {
    const {childToParent,code} = props;
    const params = useParams();
    const { ncu } = params;
    var idParque = (JSON.parse(sessionStorage.getItem("configuration"))[0].idSolarFarm);
    const variablesAPedirTracker="id,idCT,idInverter,name,actualPosition,targetPosition,status,color,notAtSetpoint,stop,motorBlocked,overcurrent,notUsed,communicationStatus,manualMode,timeStamp,colorTimeStamp";
    var [TCU, setTCU] = useState([]);
    var [htmlTCU, setHtmlTCU] = useState(<></>);

    let number2 = 0;
    useEffect(() => {
        fetch(window.location.protocol+"//"+window.location.hostname+"/api" + "/lastData/trackers?idSolarFarm="+idParque+"&idNCU="+ncu+"&variables="+variablesAPedirTracker, { method: 'GET', credentials: 'include' })
        .then( async(dataTCU) => { setTCU(await dataTCU.json());})
        .catch(e => {console.log(e);})
        var interval1=setInterval(function () {
            number2++;  
            if(code == sessionStorage.getItem("key")) { // No ha cambiado de página
                fetch(window.location.protocol+"//"+window.location.hostname+"/api" + "/lastData/trackers?idSolarFarm="+idParque+"&idNCU="+ncu+"&variables="+variablesAPedirTracker, { method: 'GET', credentials: 'include' })
                .then( async(dataTCU) => { setTCU(await dataTCU.json());})
                .catch(e => {console.log(e);})
            } else { // Ha cambiado de página. Cancela bucle
                clearInterval(interval1);
            }
        }, 30000)
    }, [number2,ncu]);

    useEffect(()=>{
        var tabla = TCU.map((datoTCU, index) => {
        const { id, idCT, idInverter, name, status, color, actualPosition, targetPosition, notAtSetpoint, stop, motorBlocked, overcurrent, notUsed, communicationStatus, manualMode,timeStamp,colorTimeStamp } = datoTCU;
    
        var _color = color;
        if(_color === "#ffffff"){_color = "#000000"};
        
        return(
            <tr className='ncu-screen-body-tr' key={index} style={{fontSize:"13px"}}>
                <td className='ncu-screen-td'><strong>{name}</strong></td>
                <td className="text-center ncu-hover-pointer ncu-screen-td" title={'Ir al CT ' + idCT} onClick={ () => window.location = '/#/ct/' + idCT}>{idCT}</td>
                <td className="text-center ncu-hover-pointer ncu-screen-td" title={'Ir al inversor ' + (idInverter - 10) + ' del CT ' + idCT} onClick={ () => window.location = '/#/inv/' + idCT + '/' + idInverter}>{idInverter - 10}</td>
                <td className="text-center ncu-screen-td" style={{color: _color}}><strong>{status}</strong></td>
                <td className="text-center ncu-screen-td">{actualPosition}º</td>
                <td className="text-center ncu-screen-td">{targetPosition}º</td>
                <td className='ncu-screen-td'><div className= {notAtSetpoint == false && communicationStatus == false &&  colorTimeStamp  !== "red" ? 'ncu-tcu-led-inactive' : 'ncu-tcu-led-active'}/></td>
                <td className='ncu-screen-td'><div className= {stop == false && communicationStatus == false &&  colorTimeStamp  !== "red" ? 'ncu-tcu-led-inactive' : 'ncu-tcu-led-active'}/></td>
                <td className='ncu-screen-td'><div className= {motorBlocked == false && communicationStatus == false &&  colorTimeStamp  !== "red" ? 'ncu-tcu-led-inactive' : 'ncu-tcu-led-active'}/></td>
                <td className='ncu-screen-td'><div className= {overcurrent== false && communicationStatus == false &&  colorTimeStamp  !== "red" ? 'ncu-tcu-led-inactive' : 'ncu-tcu-led-active'}/></td>
                <td className='ncu-screen-td'><div className= {notUsed == false && communicationStatus == false &&  colorTimeStamp  !== "red" ? 'ncu-tcu-led-inactive' : 'ncu-tcu-led-active'}/></td>
                <td className='ncu-screen-td'><div className= {communicationStatus == false &&  colorTimeStamp  !== "red" ? 'ncu-tcu-led-inactive' : 'ncu-tcu-led-active'}/></td>
                <td className='tcu-inv-screen-td'><div className={manualMode == false && communicationStatus == false &&  colorTimeStamp !== "red" ? 'ncu-tcu-led-inactive' : 'ncu-tcu-led-active'} /></td>
                <td className='text-center ncu-screen-td' style={{ color:colorTimeStamp }}>{timeStamp}</td>
            </tr>);
        });

        tabla = <Table striped bordered hover className='ncu-screen-table'>
                    <thead className='ncu-screen-thead'>
                        <tr style={{fontSize:"13px"}}>
                            <th id="ncu-min-size">TCU</th>
                            <th>CT</th>
                            <th>Inversor</th>
                            <th>Estado</th>
                            <th>Pos. Actual</th>
                            <th>Pos. Objetivo</th>
                            <th>No en SP</th>
                            <th>Stop</th>
                            <th>Motor bloq.</th>
                            <th>Sobrecorriente</th>
                            <th>Baja vel.</th>
                            <th>Com</th>
                            <th>Auto</th>
                            <th>Fecha lectura</th>
                        </tr>
                    </thead>
                    <tbody className='ncu-screen-tbody'>{tabla}</tbody>
                </Table>

        setHtmlTCU(tabla);
        },[TCU]);

        

  return (
    <div className='container-fluid' style={{marginTop: '15px'}}>
        <div className='row'>
            <div className='col' id='ncu-column-div'>
                {htmlTCU}
            </div>
        </div>
    </div>
  )
}

export default NCUTrackersList